export enum Kernels {
  R,
  Python3,
}
